import { productMetafields, variantMetafields } from './components/product-form'

export const generateMetafields = keys => {
  const separatedKeys = keys.map(key => key.split('.'))

  return separatedKeys.map(
    ([namespace, key]) => `
      ${namespace}___${key}: metafield(namespace: "${namespace}", key: "${key}") {
        namespace,
        key,
        value
      }
    `,
  )
}

const productFields = `
  id
  handle
  title
  tags
  available: availableForSale
  images(first: 1) {
    edges {
      node {
        src
      }
    }
  }
  priceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  compareAtPriceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  options(first: 25) {
    id
    name
    values
  }
  ${generateMetafields(productMetafields)}
  variants(first: 250) {
    edges {
      node {
        id
        title
        available: availableForSale
        price: priceV2 {
          amount
        }
        compareAtPrice: compareAtPriceV2 {
          amount
        }
        image {
          src
        }
        ${generateMetafields(variantMetafields)}
      }
    }
  }
  ${Object.keys(window.theme.strings.products.labels).map(
    label => `
    ${label}: metafield(namespace: "labels", key: "${label}") {
      namespace,
      key,
      value
    }
  `,
  )}
`

export const allProductsInCollectionQuery = handle => `
  query AllProductsInCollection {
    collectionByHandle(handle: "${handle}") {
      handle
      products(first: 250) {
        edges {
          node {
            ${productFields}
          }
        }
      }
    }
  }
`

export const allProductsQuery = () => `
  query AllProducts {
    products(first: 250) {
      edges {
        node {
          ${productFields}
        }
      }
    }
  }
`

export const productRecommendationsQuery = id => `
  query ProductRecommendations {
    productRecommendations(productId: "gid://shopify/Product/${id}") {
      ${productFields}
    }
  }
`

export const productMetafieldQuery = (
  ids,
  metafieldKeys = productMetafields,
) => {
  if (typeof ids === 'string') {
    ids = [ids]
  }

  return `
    query ProductMetafieldsQuery {
      products(first: 250, query: "id:${ids.join(' OR ')}") {
        edges {
          node {
            id
            ${generateMetafields(metafieldKeys)}
          }
        }
      }
    }
  `
}

export const variantMetafieldQuery = (
  productIds,
  metafieldKeys = productMetafields,
  variantMetafieldKeys = variantMetafields,
) => {
  if (typeof productIds === 'string') {
    productIds = [productIds]
  }

  return `
    query VariantMetafieldsQuery {
      products(first: 250, query: "id:${productIds.join(' OR ')}") {
        edges {
          node {
            id
            ${generateMetafields(metafieldKeys)}

            variants(first: 250) {
              edges {
                node {
                  id
                  ${generateMetafields(variantMetafieldKeys)}
                }
              }
            }
          }
        }
      }
    }
  `
}

export const metaobjectQuery = id => `
  query MetaobjectQuery {
    metaobject(id: "${id}") {
      id
      type
      fields {
        key
        value
      }
    }
  }
`

export const sellingPlansQuery = productIds => {
  if (typeof productIds === 'string') {
    productIds = [productIds]
  }

  return `
    query SellingPlansQuery {
      products(first: 250, query: "id:${productIds.join(' OR ')}") {
        edges {
          node {
            id
            sellingPlanGroups(first: 250) {
              edges {
                node {
                  name
                  sellingPlans(first: 250) {
                    edges {
                      node {
                        id
                        name
                        checkoutCharge {
                          type
                          value
                        }
                        #deliveryPolicy {
                        #  ... on SellingPlanDeliveryPolicy {
                        #    interval
                        #    intervalCount
                        #  }
                        #}
                        priceAdjustments {
                          adjustmentValue {
                            ... on SellingPlanFixedAmountPriceAdjustment {
                              adjustmentAmount {
                                amount
                              }
                            }
                            ... on SellingPlanFixedPriceAdjustment {
                              price {
                                amount
                              }
                            }
                            ... on SellingPlanPercentagePriceAdjustment {
                              adjustmentPercentage
                            }
                          }
                          orderCount
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}
